/**
 * 移动端视觉 Token —— 对齐设计稿 docs/操作人员移动端/操作人员移动端UI.html（视觉精修原型）。
 * 页面/组件内的颜色、圆角、阴影统一从这里取，避免散落的十六进制。
 */
export const T = {
  font: '"Inter","SF Pro Display","PingFang SC",system-ui,-apple-system,"Microsoft YaHei","Noto Sans SC",sans-serif',
  mono: '"SF Mono",ui-monospace,Menlo,Consolas,monospace',

  brand: '#1F6FE5',
  brandD: '#1657C0',
  brandDD: '#0F4AA8',
  brandSoft: '#EAF2FE',
  brandLine: 'rgba(31,111,229,.18)',
  brandGrad: 'linear-gradient(135deg,#2E7CEF 0%,#1657C0 100%)',
  brandShadow: '0 5px 14px rgba(31,111,229,.32)',

  appBg: 'linear-gradient(180deg,#FBFDFE 0%,#F4F8FE 56%,#EDF3FC 100%)',
  card: '#FFFFFF',

  ink: '#14202E',
  ink2: '#5A6573',
  ink3: '#9AA4B2',
  ink4: '#C2CAD6',
  line: '#EBEFF5',
  line2: '#F2F5FA',

  amber: '#F0A020',
  amberSoft: '#FEF3E3',
  amberInk: '#B26A00',
  blue: '#2D6BE0',
  blueSoft: '#E8F1FE',
  green: '#18A06B',
  greenSoft: '#E7F6EE',
  greenInk: '#0E7A50',
  danger: '#E5484D',
  dangerSoft: '#FDECEC',

  rLg: '18px',
  rMd: '14px',
  rSm: '10px',
  rPill: '999px',

  shadowSm: '0 1px 2px rgba(16,24,40,.05)',
  shadow: '0 1px 2px rgba(16,24,40,.04),0 6px 18px rgba(16,24,40,.07)',
  shadowLg: '0 8px 30px rgba(16,24,40,.10)',
} as const;

/** 语义色调（状态 pill / 统计数字 / 图标底色） */
export type Tone = 'amber' | 'blue' | 'green' | 'danger' | 'brand' | 'grey';

export const TONE: Record<Tone, { fg: string; bg: string; ink: string }> = {
  amber: { fg: T.amber, bg: T.amberSoft, ink: T.amberInk },
  blue: { fg: T.blue, bg: T.blueSoft, ink: T.blue },
  green: { fg: T.green, bg: T.greenSoft, ink: T.greenInk },
  danger: { fg: T.danger, bg: T.dangerSoft, ink: T.danger },
  brand: { fg: T.brand, bg: T.brandSoft, ink: T.brand },
  grey: { fg: T.ink3, bg: T.line2, ink: T.ink2 },
};
